export default "__VITE_ASSET__jeMSjdbE__"